<template>
  <div class="container"
       :style="{width: width + 'px', height: height + 'px', 'padding-top': top + 'px', 'padding-right': right + 'px'}">
    <div class="header" :style="{'--height' : headerHeight + 'px'}"><span v-if="!data.occupy">{{ getTitleInfo() }}
      <el-popover
        placement="right"
        trigger="hover">
        <contact-info :data="data" :display-mode="0"></contact-info>
        <svg-icon
          slot="reference"
          icon-class="telephone-fill"
          style="margin-left:5px; transform: translateY(1px); font-size:16px; color:#6071ed; cursor: pointer;"></svg-icon></el-popover></span>
      <span v-else>--</span><span class="timelong">{{ timeLong }}</span><span class="alarm"
                                                                              v-if="alarm.fhr.state">{{
          alarm.fhr.text
        }}</span>
    </div>
    <div class="content">
      <div class="wave" ref="wave">
        <fetal-monitor-atlas-view
          ref="waveContent"
          :index="index"
          :cm="cm"
          :bed-mode="bedMode"
          :data="data"
          @refresh="refresh"
        ></fetal-monitor-atlas-view>
      </div>
      <div class="param" ref="param">
        <div class="param-item" v-if="param.layout.number.fhr1.show">
          <div class="param-item-title">
            <a>{{ $t('fetalMonitor.fhr1') }}</a>
            <a>bpm</a>
          </div>
          <div class="param-item-value param-item-value-fhr1"
               :style="{'font-size': param.layout.number.fhr1.fontSize + 'px'}">
            {{ fhrData.fhr1 > -1 ? fhrData.fhr1 : '--' }}
          </div>
        </div>
        <div class="param-item" v-if="param.layout.number.fhr2.show">
          <div class="param-item-title">
            <a>{{ $t('fetalMonitor.fhr2') }}</a>
            <a>bpm</a>
          </div>
          <div class="param-item-value param-item-value-fhr2"
               :style="{'font-size': param.layout.number.fhr2.fontSize + 'px'}">
            {{ fhrData.fhr2 > -1 ? fhrData.fhr2 : '--' }}
          </div>
        </div>
        <div class="param-item" v-if="param.layout.number.toco.show">
          <div class="param-item-title">
            <a>{{ $t('fetalMonitor.uc') }}</a>
            <a>
              <el-tooltip effect="dark" content="点我，可以远程宫缩复位" placement="top-end">
                <svg-icon icon-class="toco-reset" v-on:click="tocoReset" class-name="btn-toco-reset"></svg-icon>
              </el-tooltip>
            </a>
          </div>
          <div class="param-item-value param-item-value-toco"
               :style="{'font-size': param.layout.number.toco.fontSize + 'px'}">
            {{ fhrData.toco > -1 ? fhrData.toco : '--' }}
          </div>
        </div>
        <div class="param-item" v-if="param.layout.number.fm.show">
          <div class="param-item-title">
            <a>{{ $t('fetalMonitor.fm') }}</a>
            <a>{{ $t('fetalMonitor.fetal') }}</a>
          </div>
          <div class="param-item-value param-item-value-fm"
               :style="{'font-size': param.layout.number.fm.fontSize + 'px'}">
            {{ (fhrData.fm > 0 ? fhrData.fm : '--') + '/' + (fhrData.autoFM > 0 ? fhrData.autoFM : '--') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BetterScroll from 'better-scroll'
import Global from '../common/defines'
import LayoutConfig from '../common/layout-config'
import FetalMonitorAtlasView from './FetalMonitorAtlasView'
import ContactInfo from './ContactInfo'

export default {
  name: 'FetalMonitor',
  components: {FetalMonitorAtlasView, ContactInfo},
  props: {
    index: {
      type: Number,
      required: true
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    top: {
      type: Number,
      default: 0
    },
    right: {
      type: Number,
      default: 0
    },
    cm: {
      type: Number,
      default: 0
    },
    bedMode: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      name: {},
      headerHeight: 30,
      paramItemHeight: '100%',
      scroller: null,
      param: {
        layout: null,
        cm: 0,
        bedMode: 0
      },
      fhrData: {
        fhr1: -1,
        fhr2: -1,
        toco: -1,
        fm: 0,
        autoFM: 0
      },
      alarm: {
        fhr: {
          state: false,
          text: '',
          fhr1: {
            text: [
              this.$t('fetalMonitor.fhr1Low'),
              this.$t('fetalMonitor.fhr1High')
            ]
          },
          fhr2: {
            text: [
              this.$t('fetalMonitor.fhr2Low'),
              this.$t('fetalMonitor.fhr2High')
            ]
          }
        }
      },
      timeLong: '00:00:00',
      scrollCtrl: {
        auto: true,
        task: null
      },
      widthSmallState: false
    }
  },
  created: function () {
    this.param.cm = this.cm
    this.param.bedMode = this.bedMode
    this.param.layout = LayoutConfig(this.param.bedMode)
    this.checkWidth(this.width)
  },
  mounted () {
    this.init()
  },
  watch: {
    width (newValue, oldValue) {
      console.log('watch', newValue, oldValue)
      this.checkWidth(newValue)
    }
  },
  methods: {
    init () {
      // eslint-disable-next-line no-unused-vars
      if (!this.scroller) {
        this.scroller = new BetterScroll(this.$refs.wave, {
          movable: true,
          zoom: {
            start: 1,
            min: 1,
            max: 3
          },
          scrollX: true,
          scrollY: false,
          probeType: 2
        })
        this.scroller.on('scroll', this.scroll)
      }

      if (this.data.points != null && this.data.points.length > 0) {
        this.computeFM()
      }
    },
    checkWidth (width) {
      this.widthSmallState = width < 630
    },
    scroll (pos) {
      // console.log('scroll::', pos)
      // 如果被拖动了，取消延迟恢复任务，停止移动
      // 发送一个新的延迟恢复任务
      this.clearScrollTask()
      this.scrollCtrl.auto = false
      this.scrollCtrl.task = setTimeout(this.recoverAutoScroll, 3000)
    },
    recoverAutoScroll () {
      this.scrollCtrl.auto = true
    },
    clearScrollTask () {
      clearTimeout(this.scrollCtrl.task)
    },
    refresh (width) {
      if (this.scroller) {
        this.scroller.refresh()
      }
    },
    getTimeLong () {
      let seconds = 0
      if (this.data !== null && this.data.points !== null && this.data.points.length >= Global.samplingRate) {
        seconds = parseInt(this.data.points[this.data.points.length - 1].index / Global.samplingRate, 10)
      }

      const hh = parseInt(seconds / 60 / 60, 10)
      const mm = (seconds - hh * 60 * 60) > 0 ? parseInt((seconds - hh * 60 * 60) / 60, 10) : 0
      const ss = seconds < 60 ? seconds : seconds % 60
      let time = (hh === 0 ? '00:' : (hh > 9 ? hh : '0' + hh) + ':')
      time += (mm === 0 ? '00:' : (mm > 9 ? mm : '0' + mm) + ':')
      time += (ss === 0 ? '00' : (ss > 9 ? ss : '0' + ss))
      this.timeLong = time
    },
    resize () {
      if (this.$refs.waveContent.resize(this.width, this.height - this.headerHeight)) {
        this.$refs.param.style.height = (this.height - this.headerHeight) + 'px'
        return true
      }
      return false
    },
    // changeUser: function () {
    //   console.log('changeUser1', this._oldUserKey)
    //   const userKey = this.data.userId + '@' + this.data.userType
    //   if (userKey !== this._oldUserKey) {
    //     console.log('changeUser2', userKey, this._oldUserKey)
    //     this._oldUserKey = userKey
    //     console.log('changeUser3', this._oldUserKey)
    //     this.closeAlarm()
    //   }
    // },
    paramChange: function (isRedrawn, data) {
      if (data.bedMode !== this.param.bedMode) {
        this.param.bedMode = data.bedMode
        this.param.layout = LayoutConfig(data.bedMode)
        this.reDrawWave()
      }
      this.$refs.waveContent.paramChange(isRedrawn, data)
    },
    reDrawWave () {
      this.computeFM()
    },
    computeFM () {
      this.fhrData.fm = 0
      this.fhrData.autoFM = 0
      const length = this.data.points.length
      for (let i = 0; i < length; i++) {
        if (this.data.points[i].fm) {
          console.log('fm::1', 'fm')
          this.fhrData.fm++
        }
        if (this.data.points[i].autoFM) {
          console.log('fm::1', 'auto fm')
          this.fhrData.autoFM++
        }
      }

      console.log('fm::1', this.fhrData.fm)
      console.log('fm::1', this.fhrData.autoFM)
    },
    receiveData (data) {
      if (data) {
        this.fhrData.fhr1 = data[0].fhr1
        this.fhrData.fhr2 = data[0].fhr2
        this.fhrData.toco = data[0].toco

        if (data[0].fm) {
          console.log('fm::2', 'fm', data[0])
          this.fhrData.fm++
        }
        if (data[0].autoFM) {
          console.log('fm::2', 'auto fm', data[0])
          this.fhrData.autoFM++
        }

        this.checkAlarm(data)
      }
      this.getTimeLong()
      this.$refs.waveContent.receiveData(data)
    },
    checkAlarm () {
      this.alarm.fhr.state = this.data.alarm.fhr.state
      if (this.data.alarm.fhr.state) {
        this.alarm.fhr.text = this.data.alarm.fhr.fhr1.type > -1 ? this.alarm.fhr.fhr1.text[this.data.alarm.fhr.fhr1.type] : ''
        if (this.data.alarm.fhr.fhr2.type > -1) {
          const fhr2Text = this.alarm.fhr.fhr2.text[this.data.alarm.fhr.fhr2.type]
          this.alarm.fhr.text += this.alarm.fhr.text.length > 0 ? (', ' + fhr2Text) : fhr2Text
        }
        this.playAudio(true)
      } else {
        this.closeAlarm()
      }
    },
    closeAlarm () {
      this.alarm.fhr.state = false
      this.alarm.fhr.fhr1.start = 0
      this.alarm.fhr.fhr1.type = -1
      this.alarm.fhr.fhr2.start = 0
      this.alarm.fhr.fhr2.type = -1
      this.alarm.fhr.text = ''
      this.playAudio(false)
    },
    playAudio (isPlay) {
      if (window._isInElectron) {
        window._sendToElectron('alarm-fhr-audio', {
          cmd: isPlay ? 'start' : 'stop'
        })
      }
    },
    getTitleInfo () {
      let info = `${this.$t('userList.name')}：` + this.data.name + ` ${this.$t('fetalMonitor.dueDate')}：` + (this.data.dueDate !== null ? this.data.dueDate.substring(0, 10) : '--') + ` ${this.$t('fetalMonitor.weeks')}： ` + (this.data.weeks !== null && this.data.weeks !== '' ? this.data.weeks : '--')
      if (this.alarm.fhr.state && (this.param.bedMode === 16 || this.widthSmallState)) {
        info = `${this.$t('userList.name')}：` + this.data.name
      }
      return info
    },
    startReissue () {
      console.log('fm::startReissue1', this.data)
      this.fhrData.fm = 0
      this.fhrData.autoFM = 0
      console.log('fm::startReissue2')
    },
    onMoveScroll (hasMove, x) {
      if (!this.scrollCtrl.auto) {
        return
      }

      if (!hasMove || x < 0) {
        return
      }

      const _x = x - this.$refs.wave.offsetWidth
      if (_x > 0) {
        this.scroller.scrollTo(-(_x), 0)
      }
    },
    onResize (width, height) {
      this.$refs.waveContent.onResize(width, height)
      this.refresh(width)
    },
    onImage (img) {
      this.$refs.waveContent.onImage(img)
    },
    getHeaderHeight () {
      return this.headerHeight
    },
    tocoReset (e) {
      this.$emit('tocoReset', this.data.userId, this.data.userType)
    }
    // openContact () {
    //   // this.$emit('openContact', this.data)
    //   this.$refs.contactInfo.show(this.data)
    // }
  },
  destroyed () {
    if (this.scroller) {
      this.scroller.destroy()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body, div {
  margin: 0;
  padding: 0;
  border: 0;
}

.container {
  width: 100%;
  height: 100%;
}

.header {
  height: var(--height);
  line-height: var(--height);
  background: #51d5d5;
  padding: 0 0 0 10px;

  color: #fff;
  font-size: 14px;
  font-family: 黑体, serif;
}

.header .timelong {
  margin-right: 10px;
  margin-top: 3px;
  padding: 0 5px;
  display: block;
  float: right;
  text-align: right;
  background: #1dbfbf;
  border-radius: 5px;
  height: 24px;
  line-height: 24px;
}

.header .alarm {
  margin-right: 10px;
  margin-top: 3px;
  padding: 0 25px;
  display: block;
  float: right;
  text-align: center;
  background: #f11d1d;
  border-radius: 5px;
  height: 24px;
  line-height: 24px;

  animation: fade 1200ms infinite;
}

@keyframes fade {
  from {
    opacity: 1.0;
  }
  83% {
    opacity: 1.0;
  }
  to {
    opacity: 0.0;
  }
}

.content {
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
}

.wave {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.param {
  flex: 0 0 120px;

  display: flex;
  flex-direction: column;

  height: 100%;
  background: #fff;
}

.param-item {
  flex: 1;
  width: 100%;
  border-bottom: solid 1px #9f9d9d;
  overflow: hidden;

  display: flex;
  flex-direction: column;
}

.param-item:last-child {
  border-bottom: 0;
}

.param-item .param-item-title {
  display: flex;
  align-items: center;
  height: 30px;
  font-size: 12px;
  font-family: 黑体, serif;
  color: #000;
}

.param-item .param-item-title a {
  flex: auto;
  text-align: right;
  margin-right: 10px;
}

.param-item .param-item-title a:first-child {
  text-align: left;
  margin-left: 10px;
}

.param-item .param-item-value {
  flex: 1;
  font-size: 50px;
  font-family: 黑体, serif;
  color: #e3dcdc;
  width: 100%;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
}

.param-item .param-item-value-fm {
  font-size: 35px;
  color: #7dd2a2;
}

.param-item .param-item-value-toco {
  color: #72c4e5;
}

.param-item .param-item-value-fhr1 {
  color: #f3a2a4;
}

.param-item .param-item-value-fhr2 {
  color: #f3a2a4;
}

/*定义滚动条高宽及背景
 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}

/*定义滚动条轨道
 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 1px;
  background-color: #fff;
}

/*定义滑块
 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 1px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #555;
}

.btn-toco-reset {
  color: #72c4e5;
  font-size: 18px;
  cursor: pointer;
}
</style>
